const $ = jQuery;

export default class Filter {
    constructor() {
        this.filters = [];
        $('[data-filter=1]').each((index, filter) => {
            this.initFilter($(filter));
        });
    }
    initFilter($filter) {
        const filter = {
            class: $filter.data('disabled'),
            $container: $($filter.data('container')),
            items: $filter.data('items')
        };
        this.filters.push(filter);
        $filter.on('click touchstart', '[data-filter-by]', (event) => {
            event.preventDefault();
            const $me = $(event.currentTarget),
                filterBy = $me.data('filter-by'),
                $items = filter.$container.find(filter.items);
            $items.addClass(filter.class).filter(filterBy).removeClass(filter.class);
            $filter.find('[data-filter-by]').parent().removeClass('filter__item--selected');
            $me.parent().addClass('filter__item--selected');
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/Filter.js